import { useEffect, useState } from "react";
import { useNavigate, useLocation, Link} from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import { getOrders } from '../api/commerce';
import { useParams } from "react-router-dom";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import "../css/OrderMgmt.css";


export default function About() {
  const [consoleError, setConsoleError] = useState("");
  const [ order, setOrders ] = useState([]);
  const [ orderLength, setOrderLength ] = useState([]);
  const { user, isAuthenticated } = useAuth();
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const [ loading, setLoading ] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading) {
     if (!isAuthenticated) {
      navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      } 
    }
  }, [isAuthenticated, loading, navigate, location]);
  
  const fetchOrders = async () => {
    try {
      const res = await getOrders();
      setOrders(res.data.results[0]);

      if (!order){
        setOrderLength(0)
      } else {
        setOrderLength(1)
      }
      setLoading(false)

    } catch (error) {
      setConsoleError("Error loading user information:", error);
    } 
  };

  useEffect(() => {
    fetchOrders();
  }, []);


  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) =>
    str.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);


  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])


  if (loading) return <Loading />;  

  if (!order) return (
    <>
    <NavbarLog />
    <div className="orderSuccess-page">
      <div className="order-list">
        <p>{setlang==="en" ? "No orders yet." : "تا این لحظه سفارشی وجود ندارد"}</p>
      </div>
    </div>
    <Footer />
    </>
  )
  
  else return (
    <>
      <NavbarLog />
      <div className="orderSuccess-page">
        <div className="order-list">
          {order.length === 0 ? (
            <p>{setlang==="en" ? "No orders yet." : "تا این لحظه سفارشی وجود ندارد"}</p>
          ) : (
            <>
            <h2>{setlang === "en"? "Order placed successfully" : "سفارش با موفقیت ثبت شد"}</h2>
            <div key={order.id} className="item-list">
              <ul>
                {order.items.map((item) => (
                  <li key={item.id}>
                    <div className="order-images">
                      {Array.isArray(item.product_images) && item.product_images.length > 0 &&
                        item.product_images.map((img) => (
                          <img
                            key={img.id}
                            src={img.image}
                            alt={item.product_name}
                            className="order-image"
                          />
                        ))
                      }
                      {/* Videos */}
                      {Array.isArray(item.product_videos) && item.product_videos.length > 0 &&
                        item.product_videos.map((vid) => (
                          <video
                            key={vid.id} 
                            src={vid.video}
                            controls
                            className="order-image"
                          />
                        ))
                      }
                    </div>  
                    <div className={setlang==="en"?"arrival-note":"arrival-note-fa"}>
                      <div>
                        <h3><strong>{item.product_name}</strong></h3>
                        <p><strong>{setlang==="en"?"Price: IRT":"قیمت(تومان):"} {setlang==="en"? new Number(item.price).toLocaleString():toPersiDigits(new Number(item.price).toLocaleString())}</strong></p>
                        <p><strong>{setlang==="en"?"Seller:":"فروشنده:"} {item.seller_username}</strong></p>
                        <p><strong>{setlang==="en"?"Shipped by:":"ارسال از راه:"} {item.shipping_style}</strong></p>
                        {setlang==="en"?
                        <p><strong>Note:</strong> deliveries may take <span className="highlight">up to two weeks</span>.</p>
                        :
                        <p><strong>توجه: </strong>سفارش‌های ارسالی ممکن است تا<span className="highlight"> ۱۲ روز کاری </span> به طول انجامد</p>
                        }
                        {item.arrival_date === null ? null :<span><strong>{setlang==="en"?"Arrives latest by:":"دریافت تا تاریخ:"} {setlang==="en"? dayjs.utc(item.arrival_date).calendar("jalali").locale("fa").format("YYYY/MM/DD"):toPersiDigits(dayjs.utc(item.arrival_date).calendar("jalali").locale("fa").format("YYYY/MM/DD"))}</strong></span>}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>

              <div className={setlang==="en"?"order-sum":"order-sum-fa"}>
                <p>{setlang==="en"?"Total: IRT":"قیمت(تومان):"} {setlang==="en"? new Number(order.total_amount).toLocaleString():toPersiDigits(new Number(order.total_amount).toLocaleString())}</p>
                <p>{setlang==="en"?"Order Status:":"وضعیت:"} {order.order_status}</p>
                <p>{setlang==="en"?"Order Number:":"شماره سفارش:"} {order.order_number} – {order.status}</p>
                <p>{setlang==="en"?"Placed on:":"تاریخ سفارش:"} {setlang==="en"?dayjs.utc(order.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm"):toPersiDigits(dayjs.utc(order.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm"))}</p>
              </div>
              
              <div className={setlang==="en"?"delivery-info":"delivery-info-fa"}>
                <h3>{setlang==="en"?"Delivery information":"آدرس پستی"}</h3>
                <p>{setlang==="en"?"Tracking Number:":"شماره رهگیری پست:"} {order.delivery.tracking_number}</p>
                <p>{setlang==="en"?"Delivery Status:":"وضعیت سفارش:"} {order.delivery.status}</p>
                <p>{setlang==="en"?"Delivery Date:":"تاریخ دریافت:"} {order.delivery.delivery_date || "TBD"}</p>
                <p>{setlang==="en"?"Recipient:":"نام گیرنده: "} {order.delivery.last_name} , {order.delivery.first_name} </p>
                <p>{setlang==="en"?"E-mail:":"ایمیل:"} {order.delivery.email}</p>
                <p>{setlang==="en"?"Phone No.:":"موبایل:"} {order.delivery.contact} </p>
                <p>{setlang==="en"?"Address:":"آدرس:"} {order.delivery.address} </p>
                <p>{order.delivery.city}, {order.delivery.province}, {order.delivery.country} </p>
                <p>{setlang==="en"?"Zipcode:":"کد پستی:"} {order.delivery.zipcode}</p>
              </div>

              <div className="order-actions">
                <Link to={`/${setlang}/review/open-orders`} >
                  <button className='btn'>{setlang==="en"?"view and update orders":"لیست سفارش‌ها"}</button>
                </Link>
              </div>
            </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}